/* Greenleaf — a product card shows its second photograph while the pointer is over it.
 * 11 Oct 2026, the site audit (Andrew's yes): desktop only (a real mouse), a soft fade, no badge, no
 * heart. A card with one photograph carries no data-hover and nothing changes.
 *
 * The second photograph is NOT in the page: each card's photo box (.card__shot) carries its address in
 * data-hover, and the picture is fetched the first time the pointer or the keyboard reaches the card, so
 * a shelf of 60 cards costs nothing until someone looks. The fade itself is CSS (custom.css, under
 * @media (hover:hover) and (pointer:fine)). Without this file the cards are exactly as before.
 */
(function () {
  'use strict';
  if (window.__glCardHover) return;
  window.__glCardHover = true;
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  function arm(shot) {
    if (!shot || shot.__armed) return;
    var url = shot.getAttribute('data-hover');
    if (!url) return;
    shot.__armed = true;
    var im = new Image();
    im.className = 'card__hover';
    im.alt = '';
    im.setAttribute('aria-hidden', 'true');
    im.decoding = 'async';
    im.onload = function () { shot.classList.add('has-hover'); };
    im.src = url;
    shot.appendChild(im);
  }
  function from(e) {
    var t = e.target;
    return t && t.closest ? t.closest('.card__shot[data-hover]') : null;
  }
  document.addEventListener('pointerover', function (e) { arm(from(e)); }, { passive: true });
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    var shot = t && t.closest ? t.closest('.card') : null;
    if (shot) arm(shot.querySelector('.card__shot[data-hover]'));
  });
})();
